import { computed, defineComponent, h, inject } from 'vue'

export default defineComponent({
  props: ['data'],
  setup (props) {
    const tml = computed(() => (inject('upload') as any)?.extra)
    return () => tml.value ? h(tml.value, props) : ''
  }
})
